/**
 * 传入数组关键字过滤返回
 * @param {String} val 过滤关键字，逗号隔开
 *
 * @return {string} 过滤后的数组
 */
export const showAsThousandFilter = function (val) {
    if (val === null || val === "0") {
        return "0";
    }

    if (val > 1000 || val < -1000) {
        return val.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
    } else {
        return val;
    }
};

export const FormatNumbers = function (num) {
    if (num !== undefined && num !== null) {
        num = num.toString().replace(/[$,]/g, '');
        if (isNaN(num))
            num = "0";
        let sign = (Number(num) === (num = Math.abs(num)));
        num = Math.floor(num * 100 + 0.50000000001);
        let cents = num % 100;
        num = Math.floor(num / 100).toString();
        if (cents < 10)
            cents = "0" + cents;
        for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
            num = num.substring(0, num.length - (4 * i + 3)) + ',' +
                num.substring(num.length - (4 * i + 3));
        return (((sign) ? '' : '-') + num + '.' + cents);
    }

    //传空返空字符串，因为有的时候就是需要什么都不展示，而不是展示0代替null。
    return "";
};



// WEBPACK FOOTER //
// ./src/common/js/filter.js